export const OU_WIZARD_ACCESS = "0UWizardAccess"
export const REGIME_ASSETS_ACCESS = "regimeAssetsAccess"
export const REVIEW_CHANGES_ACCESS = "reviewChangesAccess"
export const REVIEW_SFG20_CHANGES_ACCESS = "reviewSFG20ChangesAccess"
